import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import SubHeader from "../ProcessSteps/Parts/SubHeader";
import Header from "../ProcessSteps/Parts/Header";

class CouldNotFinance extends Component {
    constructor(props){
        super(props);
    }

    render() {
        return (
            <div>
                <Header title={this.props.t('step.error')}/>
                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader/>

                        <div className="row py-5">
                            <div className="col-12 d-flex justify-content-center text-center mt-4">
                                <p className="heading--2">
                                    Neteiksime Paslaugų
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(CouldNotFinance);
